/* globals validate, wc_password_strength_meter_params */

/**
 * Client-side validation for password reset/edit forms
 */
(function($) {

  // on page ready...
  $(function() {

    /**
     * NOTE: these constraints dynamically address both the reset/lost/forgot
     * password form and the edit password form that is part of the user's
     * account dashboard. We look at the elements on the page (particularly
     * the main form element) to determine what our validation constraints are.
     * Kinda hacky, but probably the best way to avoid code duplication for now.
     * TODO abstract constraints/error display away from the form page by:
     *  * creating a jQuery micro-extension with an API that lets you declare
     *    some kind of validate-able password form by passing in form/field
     *    selectors to check and put errors on
     *  * call the micro-extension twice: once for each password form
     */
    var CONSTRAINTS = {
      password_current: function(value) {
        // we only care about this field on the Edit Password form,
        // where it exists
        var presence = false;

        if (onEditPasswordPage()) {
          presence = { message: 'Please enter your current password' };
        }

        return {
          presence: presence
        };
      },
			password_1: function(value) {
				var format = false;

        if (value) {
          format = {
            pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
            message: 'Passwords must have at least one number,' +
              ' include both lowercase and uppercase letters,' +
              ' and be 8 or more characters long.',
          };
        }

        return {
          presence: { message: 'New password can\'t be blank' },
          format: format
        };
			},
			password_2: function(value) {
        var fieldWasTouched = $('[name=password_2]').hasClass('touched'),
            presence = false,
            equality = false;

        // validate presence/equality if this field has been "touched" i.e.
        // focused and left
        if (fieldWasTouched) {
          presence = {
            message: function() { return 'Please confirm your new password.'; }
          };

          // only validate equality if the user tried to confirm their pw
          if (value) {
            equality = {
              attribute: 'password_1',
              message: function() { return 'Passwords do not match'; }
            };
          }
        }

        return {
          presence: presence,
          equality: equality
        };
			}
    };

    var $submitBtn = $('.lost_reset_password input[value=Save],.edit-account input[type=submit]');
    $submitBtn.attr('disabled', true);

    function onEditPasswordPage() {
      return $('form.edit-account').length > 0;
    }

    function getValues() {
      return {
        password_current: $('[name=password_current]').val(),
        password_1: $('[name=password_1]').val(),
        password_2: $('[name=password_2]').val(),
      };
    }

    function clearErrors() {
      $('.lost_reset_password label, .edit-account label, '+
          '.lost_reset_password input, .edit-account input').removeClass('error');
      $('.validation-error').remove();
    }

    function showErrors(errors) {
      $('.woocommerce-password-hint').show();
      $.each(errors, function(name, value) {
        // Error indication on both the input and its label
        $('[name='+name+']').addClass('error').siblings('label').addClass('error');
        // display an error message
        $('<p></p>')
          .addClass('validation-error')
          .text(value)
          // match last input field row in whichever form we're on:
          // the one for the Edit Password form has to be super specific
          // TODO make this more agnostic somehow
          .insertAfter($('.form-row-last,form.edit-account .form-row:nth-of-type(3)'));
      });
    }

    function formCompleted(values) {
      return values.password_1 && values.password_2;
    }

    $('[name=password_1],[name=password_2],[name=password_current]').blur(function() {
      // have to do this repeatedly in case WP's strength checker has enabled
      // form subbmission
      $submitBtn.attr('disabled', true);

      // user has touched this field; mark it
      $(this).addClass('touched');

      clearErrors();
      var formValues = getValues();
      var errors = validate(formValues, CONSTRAINTS, {fullMessages: false});

      console.log(errors);
      if ($.isEmptyObject(errors) && formCompleted(formValues)) {
        $submitBtn.attr('disabled', false);
      } else {
        showErrors(errors);
      }
    });

  });

})(jQuery);

